import { createFeatureFlags } from '@economic/react-app';

export const { useFeatureFlags, flags } = createFeatureFlags({
    flags: [
        'disableEnforce2FACheckbox',
        'exchangeGuid',
        'onboardingChecklistWidget',
        'inAppHelpAiChatNPS',
        'journalEntryTableBackendSearch',
        'journalInlineEditing',
        'paymentLink2MobilePay',
        'purchaseStatisticsOneApi',
        'reportsHighVolumeExportWarning',
        'useCountryDropdownOnCustomer',
        'vatStatementSkatConnectAsyncRendering',
        'canNonPayingSuperUserManageUsers',
        'refactoredTransferPopup',
    ],
});

export type FeatureFlagName = (typeof flags)[number];
